import { motion } from "framer-motion";
import {
  Zap,
  ShieldCheck,
  Users,
  Ruler,
  PackageCheck,
  HeartHandshake,
} from "lucide-react";
import SectionHeading from "./SectionHeading";
import { whyHoflich } from "../data/site";

const ICONS = { Zap, ShieldCheck, Users, Ruler, PackageCheck, HeartHandshake };

export default function WhySection() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-28 md:py-40 px-6 md:px-12 bg-[#0a0a0c]"
    >
      <div className="absolute inset-0 blueprint-grid opacity-[0.05]" />
      <div className="absolute top-20 left-1/2 -translate-x-1/2 h-[300px] w-[700px] orange-glow opacity-40" />

      <div className="relative max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Why Hoflich"
          title="The compounding edge of doing this longer than anyone."
          description="Six reasons developers come back to us, project after project."
          testId="why-heading"
        />

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/5">
          {whyHoflich.map((w, i) => {
            const Icon = ICONS[w.icon] || ShieldCheck;
            return (
              <motion.div
                key={w.title}
                data-testid={`why-card-${i}`}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="group bg-[#0F0F12] p-8 md:p-10 hover:bg-[#151820] transition-colors relative"
              >
                <div className="h-14 w-14 rounded-xl border border-white/10 grid place-items-center text-[#C96A2B] bg-[#C96A2B]/5 group-hover:bg-[#C96A2B] group-hover:text-white transition-colors">
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-xl md:text-2xl mt-6">{w.title}</h3>
                <p className="mt-3 text-white/55 text-sm leading-relaxed">{w.desc}</p>
                <span className="absolute top-6 right-6 text-xs text-white/30 tracking-widest">
                  0{i + 1}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
